import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Image, Icon, Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { getImageUrl } from "../../../utils/images";

interface CardLink {
  '@id': string;
}

interface CardItem {
  imageFloated?: boolean;
  image?: string;
  header?: string;
  meta?: string;
  description?: string;
  icon?: string;
  extraText?: string;
  link?: CardLink[];
}

interface CardsViewData {
  stackable?: boolean;
  itemsPerRow?: number;
  items?: CardItem[];
}

interface CardsViewProps {
  data?: CardsViewData;
  isEditMode?: boolean;
}

const CardsView = ({
  data = {},
  isEditMode = false,
}: CardsViewProps) => {
  const {
    stackable = true,
    itemsPerRow = 3,
    items = [],
  } = data;

  if (!items.length) return null;

  const renderCard = (item: CardItem, index: number) => {
    const imageUrl = getImageUrl(item.image);

    const linkUrl = item.link?.[0]?.['@id']
      ? flattenToAppURL(item.link[0]['@id'])
      : null;

    return (
      <Card
        key={index}
        {...(
          !isEditMode && linkUrl
            ? {
                as: Link,
                to: linkUrl,
              }
            : {}
        )}
      >
        {imageUrl && !item.imageFloated && (
          <Image
            src={imageUrl}
            wrapped
            ui={false}
          />
        )}
        <Card.Content>
          {imageUrl && item.imageFloated && (
            <Image
              src={imageUrl}
              floated="right"
              size="mini"
            />
          )}
          {item.header && (<Card.Header>{item.header}</Card.Header>)}
          {item.meta && (<Card.Meta>{item.meta}</Card.Meta>)}
          {item.description && (<Card.Description>{item.description}</Card.Description>)}
        </Card.Content>
        <Card.Content extra>
          {item.icon && <Icon name={item.icon as any} />}
          {item.extraText && <span>{item.extraText}</span>}
        </Card.Content>
      </Card>
    );
  };

  return (
    <div className="cards-view">
    <Container>
      <Card.Group
        stackable={stackable}
        itemsPerRow={itemsPerRow as any}
      >
        {items.map(renderCard)}
      </Card.Group>
    </Container>
    </div>
  );
};

export default CardsView;
